import React, { useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Route,
  Link,
  Routes,
  Outlet,
  useNavigate,
  Navigate,
} from "react-router-dom";
import Banner from "../components/Banner";
import ChangePassword from "../components/ChangePassword";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import LeftSideBar from "../components/common/LeftSideBar";
import Dashboard from "../components/Dashboard";
import Login from "../components/Login";
import ForgotPassword from "../components/ForgotPassword";
import ResetPassword from "../components/ResetPassword";
import Logout from "../components/Logout";
import Profile from "../components/Profile";
import User from "../components/users/User";
import Error from "../components/Error";
import { isLoggedIn } from "../utils";
import DocumentVerification from "../components/document/DocumentVerification";
import SolarRequest from "../components/solar-request/SolarRequest";
import SolarDetails from "../components/solar-request/SolarDetails";
import FinancialPartner from "../components/financial-partner/FinancialPartner";
import MarketingPartner from "../components/marketing-partner/MarketingPartner";
import FinancialPartnerDetails from "../components/financial-partner/FinancialPartnerDetails";
import BusinessNature from "../components/business-nature/BusinessNature";
import FinancialPartnerType from "../components/FinancialPartnerType/FinancialPartnerType";
import Query from "../components/Query";
import FinancialPartnerQuery from "../components/FinancialPartnerQuery";
import UserDetails from "../components/users/UserDetails";
import AddPartner from "../components/financial-partner/AddPartner";
import FinancedByVolt from "../components/financed-by-volt/FinancedByVolt";
import SocialLinks from "../components/Settings/Settings";
import ContentManagement from "../components/ContentManagement/ContentManagement";
import Testimonials from "../components/Testimonials/Testimonials";
import AddMarketingPartner from "../components/marketing-partner/AddMarketingPartner";
import MarketingPartnerDetails from "../components/marketing-partner/MarketingPartnerDetails";
import EditMarketingPartner from "../components/marketing-partner/EditMarketingPartner";
import LeadsDetails from "../components/marketing-partner/LeadsDetails";
import UpdateUser from "../components/users/UpdateUser";
import JobsManagement from "../components/Jobs/Jobs";
import ViewApplicant from "../components/Jobs/ViewApplicant";
import BlogList from "../components/Blogs/BlogList";
import AddBlog from "../components/Blogs/AddBlog";
import EditBlog from "../components/Blogs/EditBlog";

export default function Routing() {
  const [user, setUser] = useState(null);
  //  const history = useNavigate();
  const SidebarLayout = () => (
    <>
      <Header />
      <LeftSideBar />
      <Outlet />
    </>
  );

  const ProtectedRoute = ({ children }) => {
    if (!localStorage.getItem("login")) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  //protected routes

  return (
    <HashRouter>
      <>
        <Routes>
          <Route element={<SidebarLayout />}>
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/user"
              element={
                <ProtectedRoute>
                  <User />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/user/update/:id"
              element={
                <ProtectedRoute>
                  <UpdateUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user/details/:id"
              element={
                <ProtectedRoute>
                  <UserDetails />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/solar-request/details/:id"
              element={
                <ProtectedRoute>
                  <SolarDetails />
                </ProtectedRoute>
              }
            ></Route>


            {/* <Route
              path="/category/edit/:id"
              element={<UpdateCategory />}
            ></Route> */}
            <Route
              path="/banner"
              element={
                <ProtectedRoute>
                  <Banner />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            ></Route>

            {/* solor request */}
            <Route
              path="/solar-request"
              element={
                <ProtectedRoute>
                  <SolarRequest />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/solar-request/details"
              element={
                <ProtectedRoute>
                  <SolarDetails />
                </ProtectedRoute>
              }
            ></Route>

            {/* financial partner */}
            <Route
              path="/financial-partner"
              element={
                <ProtectedRoute>
                  <FinancialPartner />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/financial-partner/add"
              element={
                <ProtectedRoute>
                  <AddPartner />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path="/financial-partner/details/:id"
              element={
                <ProtectedRoute>
                  <FinancialPartnerDetails />
                </ProtectedRoute>
              }
            ></Route>
            {/* End of Finanical partner */}

            {/* Marketing partner */}

            <Route
              path="/marketing-partner"
              element={
                <ProtectedRoute>
                  <MarketingPartner />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/marketing-partner/add-partner"
              element={
                <ProtectedRoute>
                  <AddMarketingPartner />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/marketing-partner/details/:id"
              element={
                <ProtectedRoute>
                  <MarketingPartnerDetails />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/marketing-partner/edit-partner/:id"
              element={
                <ProtectedRoute>
                  <EditMarketingPartner />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/marketing-partner/details/leads-details/:id/:marketingPartnerID"
              element={
                <ProtectedRoute>
                  <LeadsDetails />
                </ProtectedRoute>
              }
            ></Route>

            {/* End of Marketing partner */}

            {/* business nature */}
            <Route
              path="/business-nature"
              element={
                <ProtectedRoute>
                  <BusinessNature />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/financial-partner-type"
              element={
                <ProtectedRoute>
                  <FinancialPartnerType />
                </ProtectedRoute>
              }
            ></Route>

            {/* Testimonials */}
            <Route
              path="/testimonials"
              element={
                <ProtectedRoute>
                  <Testimonials />
                </ProtectedRoute>
              }
            />
    {/* JobsManagement */}
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <JobsManagement />
                </ProtectedRoute>
              }
            />
              <Route
              path="/jobs/applicant/:id"
              element={
                <ProtectedRoute>
                  <ViewApplicant/>
                </ProtectedRoute>
              }
            ></Route>


            
            {/* Blog Management */}
            <Route
              path="/blogs"
              element={
                <ProtectedRoute>
                  <BlogList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs/add"
              element={
                <ProtectedRoute>
                  <AddBlog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs/edit/:id"
              element={
                <ProtectedRoute>
                  <EditBlog />
                </ProtectedRoute>
              }
            />

            {/* Content Management */}
            <Route
              path="/content-management"
              element={
                <ProtectedRoute>
                  <ContentManagement />
                </ProtectedRoute>
              }
            />

            {/* settings */}
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SocialLinks />
                </ProtectedRoute>
              }
            />

            <Route
              path="/document-verification"
              element={
                <ProtectedRoute>
                  <DocumentVerification />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/query"
              element={
                <ProtectedRoute>
                  <Query />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/volt-finance"
              element={
                <ProtectedRoute>
                  <FinancedByVolt />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/query"
              element={
                <ProtectedRoute>
                  <Query />
                </ProtectedRoute>
              }
            ></Route>

            <Route
              path="/financial-partner-request"
              element={
                <ProtectedRoute>
                  <FinancialPartnerQuery />
                </ProtectedRoute>
              }
            ></Route>
          </Route>
          <Route path="/" element={<Login />}></Route>

          <Route path="/logout" element={<Logout />}></Route>
          <Route
            path="/reset-password/:token"
            element={<ResetPassword />}
          ></Route>
          <Route path="/forgot-password" element={<ForgotPassword />}></Route>

          <Route path="*" element={<Error />}></Route>
        </Routes>
        {/* <Footer /> */}
      </>
    </HashRouter>
  );
}
